export default __webpack_public_path__ + "static/screenshot_mines-f10f677ffda444b3f634203b6f0148fb.png";